import _get from 'lodash-es/get';
import { connect } from 'react-redux';
import GroupsTable from './GroupsTable';
import { getAllGroupsInitiate } from '../../../actions/groups';
import { currentFlowTypeEnum } from '../../common/components/constants';

const mapStateToProps = state => {
  const groupsData = _get(state, 'groups', {});
  const selectedWorkspace = _get(state, 'user.selectedWorkspace', {});
  const currentFlow = _get(
    state,
    'user.currentFlow',
    currentFlowTypeEnum.FLOW_TYPE_PPI,
  );
  return {
    currentFlow,
    selectedWorkspace,
    groupsData,
    fetchingGroups:
      _get(state, 'apiState.GET_GROUPS.isFetching', true) &&
      !_get(state, 'apiState.GET_GROUPS.isIdle', false),
    fetchedGroups: _get(state, 'apiState.GET_GROUPS.success', true),
  };
};

const mapDispatchToProps = dispatch => ({
  getAllGroups: payload => dispatch(getAllGroupsInitiate(payload)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(GroupsTable);
